$(document).ready(function() {

    let ajaxLockActive = false;

    // Ajax path
    const ajaxPath = '/action/price-level';
    const ajaxPathGetList = '/action/price-level/price-level-list';
    const ajaxPathGetEditForm = '/action/price-level/get-form/';

    activateToolTip();

    // Create price level
    $(document).on('click', 'form#price_level_form button#save_price_level', function () {
        ajaxLockActive = true;
        let name = $.trim($('form#price_level_form input#name').val());
        let buttonText = $.trim($('form#price_level_form input#button_text').val());
        let priceLevelId = 0;

        if(name === '') {
            ajaxLockActive = false;
            return false;
        }

        let priceLevelIdElement = $('form#price_level_form input[name="price_level_id"]');
        if (priceLevelIdElement.length) {
            priceLevelId = priceLevelIdElement.val() * 1;
        }

        console.log('priceLevelId: ' + priceLevelId);
        let path = ajaxPath;
        let method = 'POST';
        if (priceLevelId > 0) {
            path = path + '/' + priceLevelId
            method = 'PUT';
        }

        $.ajax({
            type: method,
            url: path,
            data: {
                name: name,
                button_text: buttonText
            },
            dataType: 'json',
        }).success(function () {
            getFormWithPriceLevelSelected(priceLevelId, true);
            refreshList();
        }).error(function () {
            displaySaveErrorMessage();
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Click on price level, fetch form to edit
    $(document).on('click', 'div#price_level_wrapper a.price_level_list_item', function () {
        let priceLevelId = $(this).attr('price_level_id');

        getFormWithPriceLevelSelected(priceLevelId, false);

        return false;
    });

    /*
	 * Change status of a PriceLevel
	 * Status = 1: active
	 * Status = 0: deactivated
	 */
    $(document).on('click', 'form#price_level_form a.change_status', function(event){
        // Get status of the selected item (active or deactivated)
        let currentStatus = $(this).attr('current_status');

        // User must confirm deactivation
        if (currentStatus === '1') {
            if (!confirm('Vil du deaktivere prisnivå?')) {
                return;
            }
        }

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        // Set correct action, activate or deactivate
        let priceLevelId = $(this).attr("id");
        let action = '';
        if (currentStatus === '1') {
            action = 'deactivate-price-level';
        } else {
            action = 'reactivate-price-level';
        }

        ajaxLockActive = true;
        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'PUT',
            url: ajaxPath + '/' + $(this).attr("id") + '/' + action
        }).success(function (data) {
            getFormWithPriceLevelSelected(priceLevelId, true);

            // Update list of PriceLevels
            refreshList();

            // Scroll window to the top
            window.scrollTo(0, 0);
        }).error(function () {
            displaySaveErrorMessage();
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', 'div#price_level_wrapper input[name="display_deactivated"]', function(event){
        refreshList();
    });

    /*
     * Display or hide filter options
     */
    $('div#price_level_list_wrapper span#filter_span_wrapper').click(function() {
        // Toggle the filters wrapper
        $('div#filter_options_wrapper').toggle();

        // Change class of the glyphicon (arrow right or down
        var arrow = $('span#filter_span_wrapper span.glyphicon');
        if ($(arrow).hasClass('glyphicon-chevron-right')) {
            // Switch to down arrow
            $(arrow).removeClass('glyphicon-chevron-right');
            $(arrow).addClass('glyphicon-chevron-down');
        } else {
            // Switch to down right
            $(arrow).removeClass('glyphicon-chevron-down');
            $(arrow).addClass('glyphicon-chevron-right');
        }
    });

    function getFormWithPriceLevelSelected(priceLevelId, includeSaveSuccessMessage) {
        $.ajax({
            type: 'GET',
            url: ajaxPathGetEditForm + priceLevelId,
            dataType: 'json',
        }).success(function (data) {
            $('div#price_level_wrapper form#price_level_form').replaceWith(data.html);

            if (includeSaveSuccessMessage) {
                displaySaveSuccessMessage();
            }

            activateToolTip();
        }).error(function () {
            displaySaveErrorMessage();
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function displaySaveSuccessMessage() {
        let element = $('form#price_level_form').find('.form-group').first();
        let successMessage = 'Trykk <a href="' + window.location.href + '"><b>her</b></a> for å lagre nytt prisnivå';

        displayAlertMessage('Prisnivå lagret!', successMessage, 'success', element);
    }

    function displaySaveErrorMessage() {
        let element = $('form#price_level_form').find('.form-group').first();
        let errorMessage = 'Kunne ikke lagre prisnivå, vennligst prøv igjen';

        displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
    }

    function activateToolTip() {
        $('form#price_level_form [data-toggle="tooltip"]').tooltip({
            placement: 'top',
            html: true
        });
    }

    function refreshList() {
        ajaxLockActive = true;

        let path = ajaxPathGetList;
        if ($('div#price_level_wrapper input[name="display_deactivated"]').is(':checked')) {
            path = ajaxPathGetList + "?include_deactivated=1";
        }
        $.ajax({
            type: 'GET',
            url: path,
            dataType: 'json',
        }).success(function (data) {
            $('div#price_level_list_wrapper div.list-group').replaceWith(data.html);
        }).error(function (data) {
            let element = $('form#price_level_form');
            let errorMessage = 'Kunne ikke oppdatere listen over prisnivå';

            displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
        }).always(function () {
            ajaxLockActive = false;
        });
    }


});